/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { SiteSection, SiteSectionFromJSON, SiteSectionFromJSONTyped, SiteSectionToJSON } from './SiteSection'

/**
 *
 * @export
 * @interface GetSiteSectionsResponseData
 */
export interface GetSiteSectionsResponseData {
  /**
   *
   * @type {Array<SiteSection>}
   * @memberof GetSiteSectionsResponseData
   */
  siteSections?: Array<SiteSection>
}

export function GetSiteSectionsResponseDataFromJSON(json: any): GetSiteSectionsResponseData {
  return GetSiteSectionsResponseDataFromJSONTyped(json, false)
}

export function GetSiteSectionsResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSiteSectionsResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    siteSections: !exists(json, 'site_sections')
      ? undefined
      : (json['site_sections'] as Array<any>).map(SiteSectionFromJSON)
  }
}

export function GetSiteSectionsResponseDataToJSON(value?: GetSiteSectionsResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    site_sections:
      value.siteSections === undefined ? undefined : (value.siteSections as Array<any>).map(SiteSectionToJSON)
  }
}
